import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NzModalService } from 'ng-zorro-antd';
import { FcinputComponent } from '../fcinput'; 
import { GRIDOPTIONS } from '../business/fclistdata.business';

@Component({
    selector: 'fc-listmodal',
    template: ``,
    styles: [`
    :host ::ng-deep .vertical-center-modal {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      :host ::ng-deep .vertical-center-modal .ant-modal {
        top: 0;
      }
    `]
})
export class FclistmodalComponent extends FcinputComponent {
    /** æ é¢ */
    @Input()
    fcTitle: string;
    @Input()
    fcRowData: any[];
    private _option: any;
    _data: any[];
    @Input()
    fcCondition: string;

    constructor(public provider: ProvidersService, public modalService: NzModalService) {
        super(provider, 'fc-listmodal');
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
        if (this.fcCondition === undefined) {
            this.fcCondition = "{}";
        }
        if (this.fcType === undefined || this.fcType === 'single') {
            this._option = {
                /**ç®è¤é»è®¤ä¸ºbootstrapé£æ ¼*/
                fcClass: 'ag-theme-blue',
                /**æ¯å¦å¯ç¨æåº*/
                fcEnableSorting: true,
                /**æ¯å¦å¯ç¨è¿æ»¤*/
                fcEnableFilter: true,
                /**æ¯å¦èªå¨è®¾ç½®è¡¨å¤´å¤§å°*/
                fcEnableColResize: true,
                /**æ¯å¦æ¾ç¤ºå·¥å·æ */
                fcShowToolPanel: false,
                /**æ¯å¦åé¡µ*/
                fcPagination: true,
                /**æ¯å¦å¯ç¨ç¶ææ */
                fcEnableStatusBar: false,
                /**æ¯å¦å¯ç¨åºåéä¸­*/
                fcEnableRangeSelection: true,
                /**éä¸­æ¹å¼*/
                fcRowSelection: 'single',
                /**æ¯å¦å¯ç¨æä½å*/
                fcEnableAction: false,
                /**éä¸­æcheckbox*/
                fcCheckboxSelection: false,
                /**æ¯å¦å¯ç¨ç¼è¾*/
                fcEnableEdit: false
            };
        } else {
            this._option = {
                /**ç®è¤é»è®¤ä¸ºbootstrapé£æ ¼*/
                fcClass: 'ag-theme-blue',
                /**æ¯å¦å¯ç¨æåº*/
                fcEnableSorting: true,
                /**æ¯å¦å¯ç¨è¿æ»¤*/
                fcEnableFilter: true,
                /**æ¯å¦èªå¨è®¾ç½®è¡¨å¤´å¤§å°*/
                fcEnableColResize: true,
                /**æ¯å¦æ¾ç¤ºå·¥å·æ */
                fcShowToolPanel: false,
                /**æ¯å¦åé¡µ*/
                fcPagination: true,
                /**æ¯å¦å¯ç¨ç¶ææ */
                fcEnableStatusBar: false,
                /**æ¯å¦å¯ç¨åºåéä¸­*/
                fcEnableRangeSelection: true,
                /**éä¸­æ¹å¼*/
                fcRowSelection: this.fcType,
                /**æ¯å¦å¯ç¨æä½å*/
                fcEnableAction: false,
                /**éä¸­æcheckbox*/
                fcCheckboxSelection: true,
                /**æ¯å¦å¯ç¨ç¼è¾*/
                fcEnableEdit: false
            };
        }
    }
    showModal(): any {
        let _this1 = this;
        let option: FclistmodalOption = {
            options: this._option,
            rowData: this.fcRowData,
            appId: this.fcAppid,
            condition: this.fcCondition
        };
        const subscription = this.modalService.create({
            nzTitle: this.fcTitle,
            nzContent: FclistmodalComponent,
            nzWrapClassName: "vertical-center-modal",
            nzWidth: "70%",
            nzOnOk() {
                _this1.event( "success", _this1._data );
            },
            nzOnCancel() {
                _this1.event("cancle", [] );
            },
            /** nzfooter: true,*/
            nzComponentParams: {
                fcOption: option//ä¿®æ¹
            }
        });
        subscription.afterClose.subscribe(result => {
            if (result instanceof Array) {
                this._data = result;
            }
            if (this.fcType === 'single' && result.length === 1) {
                subscription.destroy('onOk');
            }
        });
    }
}
export interface FclistmodalOption {
    options: GRIDOPTIONS,
    rowData: any,
    appId: string,
    condition: string
}
